module.exports = __webpack_public_path__ + "img/blog-cover-instagram-blurry.72699114.webp";